import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import ChallengeList from './components/ChallengeList';
import ChallengeDetail from './components/ChallengeDetail';
import AdminPanel from './components/AdminPanel';
import AdminLogin from './components/AdminLogin';
import AdminRoute from './components/AdminRoute';

function App() {
  return (
    <div className="min-h-screen bg-[#121212] text-[#E0E0E0]">
      <div className="container mx-auto px-4">
        <Header />
        
        <main className="py-6">
          <Routes>
            <Route path="/" element={<ChallengeList />} />
            <Route path="/challenge/:id" element={<ChallengeDetail />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={
              <AdminRoute>
                <AdminPanel />
              </AdminRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        
        <footer className="py-6 mt-10 border-t border-[#333333] text-center text-gray-500 text-sm">
          <p>© 2025 FrameQuest. Created by Jaz Blakeston-Petch</p>
        </footer>
      </div>
    </div>
  );
}

export default App;